import { Component, Input, OnChanges, OnDestroy, OnInit } from "@angular/core";
import { Question } from "src/app/Models/question.interface";
import { LanguageSwitchService } from "src/app/Services/LanguageSwitch/language-switch.service";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { ProfileComponent } from "../profile/profile.component";
import { Subject } from "rxjs";

@Component({
  selector: "question",
  templateUrl: "./question.component.html",
  styleUrls: [
    "./question.component.scss",
    "../../templates/question-template/svg.scss",
    "../../templates/question-template/question-template.component.scss",
  ],
})
export class QuestionComponent implements OnInit, OnDestroy {
  @Input() question: Question;
  @Input() profile: ProfileComponent;
  leaving = new Subject();
  allCorrect;
  config;

  constructor(private um: UserManager, private ls: LanguageSwitchService) {}

  ngOnDestroy(): void {
    this.leaving.next();
  }
  ngOnInit(): void {
    this.ls.config.takeUntil(this.leaving).subscribe({
      next: (config) => {
        this.config = config;
      },
    });
  }
}
